export default "__VITE_ASSET__Br69iXb8__"